import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import './NotificationStore.css';
import Modal from '../../Components/Modal/Modal';
import { IoMdArrowRoundBack } from "react-icons/io";
import { FaChevronDown, FaChevronUp, FaHeadset } from "react-icons/fa";
import { usePaginatedPost } from '../../hooks/usePaginatedPost';
import config from '../../config';
import moment from 'moment-jalaali';
import api from '../../hooks/api';
import TelegramSafeArea from '../TelegramSafeArea';

function NotificationStore({ fn_close, isShow, businessId }) {

    const [cursor, setCursor] = useState(null);
    const [messageFilter, setMessageFilter] = useState('unread'); // unread | read
    const [expandedMessageId, setExpandedMessageId] = useState(null);

    let activeSearchUrl = null;
    let payload = { business_id: businessId, row_count: 10 };

    if (messageFilter === 'unread') {
        activeSearchUrl = `support/message/business/unread`;
    } else {
        activeSearchUrl = `support/message/business/read`;
    }

    const { 
        data: apiData, 
        loading: apiLoading, 
        isLastPage, 
        nextCursor, 
        setData: setApiData 
    } = usePaginatedPost(activeSearchUrl, payload, cursor);

    useEffect(() => {
        setExpandedMessageId(null);
    }, [messageFilter]);

    const handleClose = () => {
        fn_close();
    };

    const formatDateJalali = (dateStr) => {
        if (!dateStr) return '---';
        return moment(dateStr).format('jYYYY/jMM/jDD HH:mm');
    };

    const handleSeenSystemMessage = (id) => {
        api.post(`support/message/business/seen`, { supportMessage_id: id, business_id: businessId })
            .then((response) => { })
            .catch((error) => { console.error(error); });

        if (setApiData) {
            setApiData(prevData => prevData.map(msg => {
                if (msg.id === id) {
                    return { ...msg, is_locally_seen: true };
                }
                return msg;
            }));
        }
    };

    const handleToggleSystemMessage = (msgId) => {
        if (messageFilter === 'read') return;

        if (expandedMessageId === msgId) {
            setExpandedMessageId(null);
        } else {
            setExpandedMessageId(msgId);
            if (messageFilter === 'unread') {
                const targetMsg = apiData.find(m => m.id === msgId);
                if (targetMsg && !targetMsg.is_locally_seen) {
                    handleSeenSystemMessage(msgId);
                }
            }
        }
    };

    const LoadingSpinner = () => (
        <div className="loading-container">
            <div className="ns-spinner"></div>
        </div>
    );

    // استفاده از createPortal برای رندر در بالاترین سطح
    return createPortal(
        <div style={{ position: 'relative', zIndex: 999999 }}>
            <Modal eventToggle={handleClose} isOpen={isShow} locked={true} fullscreen={true}>
                <div className="notification-store">
                    
                    {/* ---------------- TelegramSafeArea ---------------- */}
                    <TelegramSafeArea style={{ background: "#ffffff", color: "#000" }}>
                        <div
                            className="safe-area-title"
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                lineHeight: '1.3',
                                padding: '5px 0'
                            }}
                        >
                            <span style={{ fontSize: '15px', fontWeight: 'bold' }}>سبد 1</span>
                            <span style={{ fontSize: '12px', opacity: 0.85 }}>فروشگاه آنلاین</span>
                        </div>
                    </TelegramSafeArea>
                    {/* -------------------------------------------------- */}

                    <div className="ns-topbar">
                        <div className="ns-title">اعلان‌های سبد۱</div>
                        <div className="ns-back" onClick={handleClose}>
                            <IoMdArrowRoundBack size={"24px"} />
                        </div>
                    </div>

                    <div className="ns-content">
                        <div className="filter-switch-container">
                            <div
                                className={`filter-option ${messageFilter === 'unread' ? 'active' : ''}`}
                                onClick={() => { 
                                    setMessageFilter('unread'); 
                                    setCursor(null);
                                }}
                            >
                                خوانده نشده
                            </div>
                            <div
                                className={`filter-option ${messageFilter === 'read' ? 'active' : ''}`}
                                onClick={() => { 
                                    setMessageFilter('read'); 
                                    setCursor(null);
                                }}
                            >
                                خوانده شده
                            </div>
                        </div>

                        {apiLoading && cursor === null ? (
                            <LoadingSpinner />
                        ) : (
                            <div className="messages-list">
                                {apiData && apiData.length > 0 ? (
                                    apiData.map(msg => {
                                        const isExpanded = messageFilter === 'read' || expandedMessageId === msg.id;
                                        const groupTitle = msg.message_group?.title;

                                        return (
                                            <div
                                                key={msg.id}
                                                className={`message-card ${isExpanded ? 'expanded' : ''}`}
                                                onClick={() => handleToggleSystemMessage(msg.id)}
                                                style={{ cursor: messageFilter === 'read' ? 'default' : 'pointer' }}
                                            >
                                                <div className="msg-header">
                                                    <div className="store-info">
                                                        {msg.image ? (
                                                            <img
                                                                src={`${config.api.imageURL}/${msg.image}`}
                                                                alt="System"
                                                                onError={(e) => { e.target.src = process.env.PUBLIC_URL + '/images/avator.jpg' }}
                                                            />
                                                        ) : (
                                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '40px', height: '40px', minWidth: '40px', borderRadius: '50%', backgroundColor: '#e3f2fd', color: '#1976d2' }}>
                                                                <FaHeadset size={22} />
                                                            </div>
                                                        )}
                                                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                            <span className="store-name">{msg.title || 'پیام سیستم'}</span>
                                                            {groupTitle && (
                                                                <span className="msg-group-title">{groupTitle}</span>
                                                            )}
                                                        </div>
                                                    </div>

                                                    <div className="msg-meta">
                                                        <span className="msg-date">{formatDateJalali(msg.created_at)}</span>
                                                        {messageFilter !== 'read' && (
                                                            <div className="chevron-icon">
                                                                {isExpanded ? <FaChevronUp color="#999" size={10} /> : <FaChevronDown color="#999" size={10} />}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>

                                                {isExpanded && (
                                                    <div className="msg-body show-anim">
                                                        {msg.messages || msg.message || msg.text}
                                                    </div>
                                                )}
                                            </div>
                                        );
                                    })
                                ) : (
                                    <div className="empty-state">
                                        {messageFilter === 'unread' ? 'پیام سیستمی جدیدی ندارید.' : 'پیام سیستمی خوانده شده‌ای وجود ندارد.'}
                                    </div>
                                )}

                                {!isLastPage && nextCursor && apiData && apiData.length > 0 && (
                                    <button
                                        className="load-more-btn"
                                        onClick={() => setCursor(nextCursor)}
                                        disabled={apiLoading}
                                    >
                                        {apiLoading ? 'در حال دریافت...' : 'نمایش بیشتر'}
                                    </button>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </Modal>
        </div>,
        document.body
    );
}

export default NotificationStore;
